<template>
    <div>
        <div id="footer-text">
            <div class="footer-content">
                &copy; MOCO INK {{(new Date()).getYear() + 1900}}. All rights reserved.<br/>
            </div>
            <div class="footer-content">
                <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2021007668号</a>
                {{this.$lang.footer}}
            </div>
            <div id="circle-footer"></div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "TheFooter"
	}
</script>

<style scoped lang="scss">

    #footer {
        @media #{$tablet} {
            padding-top: 32px;
        }

        @media #{$tablet-inv} {
            padding-top: 64px;
        }
    }

    #footer-text {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: $d-fg;
        font-size: 12px;
        box-sizing: border-box;
        height: 90px;
        border-bottom: solid 8px $p-accent;
        text-align: center;

        @media #{$tablet} {
            padding: 20px 0;
        }

        @media #{$tablet-inv} {
            padding: 20px;
        }

        width: 100%;
        left: 0;
    }

    #footer-text::after {
        content: " ";
        position: absolute;
        height: 100%;
        left: 0;
        right: 0;
        border-top: $solid;
        border-bottom: $solid;
        bottom: 0;
        box-sizing: border-box;
    }

    .footer-content {
        z-index: 1;
    }

    #footer-text > div:first-child {
        color: $p-fg;
        font-family: $serif;

        @media #{$tablet} {
            font-size: 14px;
        }

        @media #{$tablet-inv} {
            font-size: 16px;
        }
    }
</style>